import Nominations from '@/services/Api/Awards/Nominations';
import { handleAuthorization, handleFormValidations } from '@ifac/ui';

export default {
  data() {
    return {
      formValues: null,
      isLoading: false,
    };
  },
  methods: {
    mx_fetchNomination() {
      this.isLoading = true;
      return Nominations.get(this.mx_nominationId);
    },
    mx_updateNomination(payload) {
      this.formErrors = {};
      return Nominations
        .update(this.nomination.id, {
          form_values: payload,
        })
        .then((response) => {
          this.$snack.success({ text: 'Nomination saved' });
          return response;
        })
        .catch((error) => {
          this.handleError(error);
          throw error;
        });
    },
    handleError(error) {
      handleAuthorization(error).then((msg) => {
        if (msg) {
          this.$snack.success({ text: msg });
        }
      });

      handleFormValidations(error).then((errors) => {
        if (errors) {
          this.$snack.success({
            text: 'You have some validation errors, try again please.',
          });
          this.formErrors = errors;
        }
      });
    },
  },
  computed: {
    mx_nominationId() {
      return this.$route.params.nomination;
    },
    mx_loaderHeight() {
      return 110;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('awards/setCurrentAward', null);
    next();
  },
};
